import request from '@/utils/request';

export function getAddress(params: any) {
  return request({
    url: 'address/address',
    method: 'get',
    params
  });
}
export function editAddress(data: any) {
  return request({
    url: 'address/address',
    method: 'put',
    data
  });
}
export function addAddress(data: any) {
  return request({
    url: 'address/address',
    method: 'post',
    data
  });
}
export function deleteAddress(data: any) {
  return request({
    url: 'address/address',
    method: 'DELETE',
    data
  });
}
